





















import {computed, defineComponent, reactive, watch} from "@vue/composition-api"
import {getAutocompleteFn} from "@/data/sources/autocomplete"
import {globalParams, saveGlobalParams} from "@/components/widgets/WidgetMother"
import {bus} from "@/main"

export default defineComponent({
  setup() {
    const lookupFn = getAutocompleteFn("locationAutocomplete")
    const locationInfo = reactive({
      available: false,
      name: "",
      organization: false,
      region: false,
      site: false,
      building: false,
      floor: false,
      room: false,
      override: computed({
        get: () => globalParams.locationId._override,
        set: (v) => globalParams.locationId._override = v,
      }),
    })

    watch(() => globalParams.locationId, async () => {
      saveGlobalParams()
      const r = await lookupFn(globalParams.locationId.value, true)
      Object.assign(locationInfo, {
        ...r[0],
        available: true,
        organization: r[0]["type"] === "o",
        region: r[0]["type"] === "g",
        site: r[0]["type"] === "s",
        building: r[0]["type"] === "b",
        floor: r[0]["type"] === "f",
        room: r[0]["type"] === "r",
      })
    }, {deep: true})

    function showGlobalSettings() {
      bus.$emit("showGlobalSettings")
    }

    return {locationInfo, showGlobalSettings}
  },
})
